import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import Axios from "./components/Axios";
import SideBar from "./components/SideBar";
import NavBar from "./components/NavBar";
import Authenticated from "./components/Authenticated";

import Login from "./pages/Login";
import Logout from "./pages/Logout";
import PDF from "pages/PDF";
import ConfiguratorPage from "pages/ConfiguratorAppPage/ConfiguratorPage";
import ConfiguratorAppPage from "pages/ConfiguratorAppPage";
import CustomerQuotesPage from "pages/CustomerQuotesPage";

function App() {
  return (
    <Router>
      <Axios />
      <Switch>
        <Route
          exact
          path="/"
          render={() => (
            <Authenticated
              render={() => {
                return <Login />;
              }}
            />
          )}
        />
        <Route exact path="/logout" component={Logout} />
        <Route
          path="/admin"
          render={(props) => (
            <div>
              <NavBar {...props} />
              <SideBar {...props} />
            </div>
          )}
        />

        <Route
          exact
          path={`/pdf/:configurationId`}
          render={() => {
            return <PDF />;
          }}
          // <Authorized
          //   render={() => {
          //     return <PDF />;
          //   }}
          // />
          // )
          // }
        />

        <Route
          exact
          path="/configurable-products"
          component={ConfiguratorAppPage}
        />
        <Route exact path="/server-configurator" component={ConfiguratorPage} />
        <Route exact path="/quotes" component={CustomerQuotesPage} />
      </Switch>
    </Router>
  );
}

export default App;
